
import { HasError, loading_cart, recalculate_cart_total, remove_from_cart, set_cart, update_cart, update_cart_display_status} from "../constants/cart.constant";
import { ActionsUnion } from "../cart.action";
import { CartState } from "../../../Entites/cart.model";





function getIntialState()
{
  let initialState: CartState  = {
    cart_list: [],
    cart_total: 0,
    cart_display_status: false,
    loading_cart: true,
    error:'',
    voucher_code: '',
    voucher_percentage: 0,
    cart_total_with_voucher: 0,
    checkout_notes: '',
    voucher_data: undefined
  };

  return initialState
}

export function CartReducer (state = getIntialState(), action: any)
{

  switch ( action.type )
  {
    case update_cart_display_status:
      return {...state,cart_display_status:action.data};
    break;

    case set_cart:

      let new_cart = {
        ...state,
        cart_list: action.data,loading_cart:false
      };
      return new_cart;
      break;


      case HasError:

      return {...state,error:action.data}


      case loading_cart:

      return {...state,loading_cart:true}
    break;
    case recalculate_cart_total:


      return {
        ...state,
        cart_total: action.data
      };
    break;
case update_cart:

let amount = action.data.new_amount
  const updatedItems = state.cart_list.map((cartItem) => {
    if (cartItem.id === action.data.cart_id) {
      // Update the amount property of the matching item
      return { ...cartItem, amount };
    }
    return cartItem;
  });
  let updatecart = {
    ...state,
    cart_list:updatedItems
  };
  return updatecart;

break;
case remove_from_cart:


let deletedCart = {
  ...state,
  cart_list:state.cart_list.filter(data=>data.id != action.data)
};
return deletedCart;

break;


    default:
      return state;

  }

}
